import styled from 'styled-components';
import { ComplementaryColor, Spacer } from '@lux/core';
import { Text } from '@lux/text';
import { Title } from '@lux/title';

export const GRECarouselWrapper = styled.div`
    margin-bottom: ${Spacer.SM};
`;

interface CyberWeekProps {
    $isCyberWeek?: boolean;
}

export const GRETitle = styled(Title)<CyberWeekProps>`
    width: 100%;
    margin: 0;
    text-align: center;
    ${props => props.$isCyberWeek && `color: ${ComplementaryColor.neonFresh} !important;`}
`;

export const GREDescription = styled(Text)<CyberWeekProps>`
    display: block;
    width: 100%;

    margin: 0;
    text-align: center;
    ${props => props.$isCyberWeek && `color: ${ComplementaryColor.neonFresh} !important;`}
`;
